import { useGetUserSsoStatusQuery } from 'features/security/authApi';
import _, { debounce } from 'lodash';
import HelperFunctions from 'pages/global/HelperFunctions';
import { useEffect, useMemo, useState } from 'react';

export function useGetUserSsoStatus(username = '') {
    const [emailToCheck, setEmailToCheck] = useState(username);

    const userSsoStatus = useGetUserSsoStatusQuery(emailToCheck, {
        // selectFromResult: (result) => result?.currentData,
        skip: _.isEmpty(emailToCheck) || HelperFunctions.emailIsValid(emailToCheck) === false,
    });

    const debouncedResults = useMemo(() => {
        return debounce((value) => {
            setEmailToCheck(value);
        }, 500);
    }, []);

    useEffect(() => {
        debouncedResults(username);
    }, [username]);

    return userSsoStatus.currentData ?? { ssoEnabled: false, ssoType: '', slug: null };
}
